module.exports = __webpack_public_path__ + "static/media/1350_popup_Exit_Medical_all.70c219a7.png";